
import { Component, Prop, Vue } from "vue-property-decorator";
import store from "../../core/store";
import { Format } from "@shared/core/helpers/formatHelper";
import ScrollableBanner from "@shared/crm/components/scrollableBanner.vue";
import { TenantSettings } from "../../../shared/core/services/configService";

@Component({
  components: {
    ScrollableBanner,
  },
})
export default class LocationsBanner extends Vue {
  @Prop({ required: true }) private locations!: any[];
  private images: any[] = [];
  settings: TenantSettings = {};
  selectedLocation = "";

  async mounted() {
    this.settings = store.state.settings;
    const currentUrl = window.location.origin;
    console.log(currentUrl, this.locations); 
    const matchedLocation = this.locations.find(location => {
      try {
        const locUrl = new URL(location.url);
        return locUrl.origin === currentUrl;
      } catch {
        return false;
      }
    });
     if (matchedLocation) {
      this.selectedLocation = matchedLocation.url;
    }
    this.setDefaultImages();
  }

private setDefaultImages() {
    const context = require.context(
      "@/images/bookingtypes",
      false,
      /\.(png|jpe?g|webp|gif)$/
    );
    this.images = context.keys().map(context);
  }

  private getImageType(name: string, index: number) {
    if (name != null && name !== "") {
      return name;
    }
    return this.images[index % this.images.length];
  }
}
